import { REGEX_PARTS_DATE } from '../../../inputPatterns/date/constants';
import { REGEX_PARTS_TIME } from '../../../inputPatterns/time/constants';

const { YYYY, MM, DD } = REGEX_PARTS_DATE;
const { HH_24, MM: MM_TIME, SS, SSS, DOT } = REGEX_PARTS_TIME;

export const PARTIAL_ISO_LABEL = {
  YYYY_MM_DDTHH_MM: 'YYYY-MM-DDTHH:mm',
  YYYY_MM_DDTHH_MM_SS: 'YYYY-MM-DDTHH:mm:ss',
  'YYYY_MM_DDTHH_MM_SS.SSS': 'YYYY-MM-DDTHH:mm:ss.SSS',
} as const;
const ISO_PATTERNS: Record<string, string> = {
  [PARTIAL_ISO_LABEL.YYYY_MM_DDTHH_MM]: `${YYYY}-${MM}-${DD}T${HH_24}:${MM_TIME}`,

  [PARTIAL_ISO_LABEL.YYYY_MM_DDTHH_MM_SS]: `${YYYY}-${MM}-${DD}T${HH_24}:${MM_TIME}:${SS}`,
  [PARTIAL_ISO_LABEL['YYYY_MM_DDTHH_MM_SS.SSS']]: `${YYYY}-${MM}-${DD}T${HH_24}:${MM_TIME}:${SS}${DOT}${SSS}`,
};
export const ISO_REGEXES = {
  ISO_WITH_SECOND: new RegExp(`^${ISO_PATTERNS[PARTIAL_ISO_LABEL.YYYY_MM_DDTHH_MM_SS]}$`),
  ISO_WITH_MINUTE: new RegExp(`^${ISO_PATTERNS[PARTIAL_ISO_LABEL.YYYY_MM_DDTHH_MM]}$`),
  ISO_WITH_MILLISECOND: new RegExp(`^${ISO_PATTERNS[PARTIAL_ISO_LABEL['YYYY_MM_DDTHH_MM_SS.SSS']]}$`),
};
